import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { createContext, memo, ReactNode, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';

export type FacadeInspectionContextProps = {
  containerWidth: number;
  interacted$: BehaviorSubject<boolean>;
};

export const FacadeInspectionContext =
  createContext<FacadeInspectionContextProps>(null as any);

export const useFacadeInspectionContext = () =>
  useContext(FacadeInspectionContext);

export const FacadeInspectionContextProvider = memo(
  ({
    children,
    interacted$,
  }: {
    children?: ReactNode;
    interacted$: BehaviorSubject<boolean>;
  }) => {
    return (
      <LayoutProviderView
        css={`
          flex: 1;
        `}
      >
        {size => (
          <FacadeInspectionContext.Provider
            value={{ containerWidth: size.width, interacted$ }}
          >
            {children}
          </FacadeInspectionContext.Provider>
        )}
      </LayoutProviderView>
    );
  },
);
